<template>
  <div id="app" @mousemove="changeBgShadow">
    <div class="bg">
      <div class="circle" :style="backgroundStyle"></div>
    </div>

    <Header :linkedin="myLinkedin"/>

    <Welcome>
      <span class="dark-grey">{{ $t('welcome.im') }} {{ $t('welcome.firstName') }},</span> <span class="dark br-mobile">{{ $t('welcome.contract') }}</span><br />
      <span class="green br-mobile">{{ $t('welcome.title1') }}</span> <span class="light-grey">{{ $t('welcome.and') }}</span> <span class="pink">{{ $t('welcome.title2') }}</span><br />
      <span class="dark br-mobile small">{{ $t('welcome.status') }} <a href="#footer" v-scroll-to="'#footer'">{{ $t('cta') }}</a></span>
    </Welcome>

    <Clients :my-clients="myClients"/>

    <Skills :my-skills="mySkills"/>

    <Positions :my-positions="myPositions"/>

    <ContactBar :phone="myPhone" :email="myEmail" :whatsapp="myWhatsapp"/>

    <Footer>
      {{ $t('cta') }}
    </Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from "../components/Footer"
import ContactBar from "../components/ContactBar"
import Welcome from '../components/Welcome.vue'
import Clients from '../components/Clients.vue'
import Skills from '../components/Skills.vue'
import Positions from '../components/Positions.vue'

export default {
  name: 'app',
  components: {
    Header, Footer, ContactBar,
    Welcome, Clients, Skills, Positions
  },
  data() {
    return {
      darkMode: true,
      backgroundStyle: {},
      myPhone: '0542257391',
      myWhatsapp: 'https://wa.me/972542257391',
      myEmail: 'info@galevy.co.il',
      myLinkedin: 'https://www.linkedin.com/in/gal-levy/',
      mySkills: [
        //language
        {name: 'PHP',                   type: 'primary'},
        {name: 'Laravel',               type: 'secondary'},
        {name: 'Python',                type: 'primary'},
        {name: 'SQL',                   type: 'primary'},
        {name: 'MySQL',                 type: 'secondary'},
        {name: 'JavaScript',            type: 'primary'},
        {name: 'Vue.js',                type: 'secondary'},
        {name: 'jQuery',                type: 'secondary'},
        {name: 'Bootstrap',             type: 'secondary'},
        {name: 'CSS',                   type: 'primary'},
        {name: 'SCSS/Sass/Less',        type: 'secondary'},
        {name: 'TailwindCSS',           type: 'secondary'},
        {name: 'Bulma',                 type: 'secondary'},
        {name: 'HTML',                  type: 'primary'},
        {name: 'C#',                    type: 'primary'},
        {name: 'Flutter',               type: 'secondary'},
        //tools
        {name: 'API',                   type: 'tertiary'},
        {name: 'Git',                   type: 'tertiary'},
        {name: 'webpack',               type: 'tertiary'},
        {name: 'WordPress',             type: 'tertiary'},
        {name: 'Jira/Asana/Trello',     type: 'tertiary'},
        {name: 'AWS',                   type: 'tertiary'},
      ],
      myClients: [
        {name: 'pinyata'}, {name: 'riskified'}, {name: 'hot'}, {name: 'groo'}, {name: 'azrieli'}, {name: 'medison'}
      ],
      myPositions: [
        {
          id: 8,
          year: '2021 - ' + this.$t('roles.now'),
          role: "CTO",
          company: "Apptodate",
          contact: false,
        },
        {
          id: 7,
          year: '2021',
          role: "Development Team Leader",
          company: "Riskified",
          contact: false,
        },
        {
          id: 6,
          year: '2018 - 2020',
          role: "R&D Manager",
          company: "Pinyata",
        },
        {
          id: 5,
          year: '2017 - 2018',
          role: "Development Team Leader",
          company: "inManage",
        },
        {
          id: 4,
          year: '2015 - 2017',
          role: "Senior PHP Developer",
          company: "inManage",
        },
        {
          id: 3,
          year: '2013 - 2015',
          role: "R&D Manager, Co-founder",
          company: "Glass",
        },
        {
          id: 2,
          year: '2010 - 2013',
          role: "Senior Software Programmer",
          company: "IDF",
        },
        {
          id: 1,
          year: 'Since 2007',
          role: "Full Stack Developer",
          company: "Freelance",
        }
      ]
    };
  },
  methods: {
    toggleDarkMode: function(e) {
      e.preventDefault()
      this.darkMode = !this.darkMode
      document.body.classList.toggle('dark-mode')
    },
    changeBgShadow: function (event) {
      if(!this.isMobile()) {
        let x = -(event.clientX - (window.innerWidth / 2)) / 2
        let y = -(event.clientY - (window.innerHeight / 2)) / 2

        let newBoxShow = x + 'px ' + y + 'px 250px ' + (document.body.classList.contains('dark-mode') ? 'rgba(0, 209, 178, 0.16)' : 'rgba(231, 61, 183, 0.16)')

        this.backgroundStyle = {
          boxShadow: newBoxShow
        }
      }
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="sass">
#app
//
</style>

<style lang="sass" scoped>
.bg
  overflow: hidden
  position: fixed
  width: 100%
  height: 100vh
  display: flex
  justify-content: center
  align-items: center
  z-index: -1

  .circle
    transition: 0s
    width: 70vh
    border-radius: 50%
    background-color: $light
    box-shadow: 170px 103px 250px rgba(231, 61, 183, 0.16)

    &:before
      content: ""
      display: block
      padding-top: 100%

@media screen and (max-width: $mobile-break-point)
  .bg
    .circle
      width: 700px
</style>